
export enum KEYS {
  ALL = "all",
  USDT = "usdt",
  USDC = "usdc",
  FAV = "fav",
  MFT = "mft"
};

export enum TYPES {
  UP = "up",
  DOWN = "down",
  NONE = ""
};

export enum NAMES {
  TITLE = "title",
  NAME = "pair_name",
  PRICE = "l_p",
  CHANGE = "change_24"
};

interface IMarketList {
  id: KEYS,
  name: string
}
export const marketList: IMarketList[] = [
  {
    id: KEYS.ALL,
    name: "market.market_all_type_text",
  },
  {
    id: KEYS.USDT,
    name: "USDT",
  },
  {
    id: KEYS.USDC,
    name: "USDC",
  }
];

export const marketListMFT: IMarketList[] = [
  ...marketList,
  {
    id: KEYS.MFT,
    name: "MFT",
  },
]

interface ITableHeadColumn {
  name: NAMES,
  title: string,
  subTitle: string,
}

export const tableHeadColumn: ITableHeadColumn[] = [
  {
    name: NAMES.NAME,
    title: "market.market_text",
    subTitle: "",
  },
  {
    name: NAMES.PRICE,
    title: "market.last_price_text",
    subTitle: "",
  },
  {
    name: NAMES.CHANGE,
    title: "market.Chg_text",
    subTitle: "24h ",
  },
];

export const tableHeadColumnMFT: ITableHeadColumn[] = [
  {
    name: NAMES.TITLE,
    title: "Name",
    subTitle: "",
  },
  ...tableHeadColumn
];